import { global } from '../constants';

export const data = {
  banner: {
    background: global.banner + '1.jpg',
    title: 'Global Services',
    crumb: 'Global Services',
  },

  services: {
    title: 'Global services',
    subtitle: 'Trusted For Global Services',
    description:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry the standard dummy text ever since the  when an printer took.',
    services: [
      {
        image: global.sgallery + '1.jpg',
        title: 'Private Client Storage',
        serial: '01',
        path: '/services/global-services/private-client-storage',
        shortDescription:
          'Our vaulting facilities are built to provide you with state‑of‑the‑art...',
        description:
          'Our vaulting facilities are built to provide you with state‑of‑the‑art precious metals storage services, including primary dedicated pick‑and‑pack and storage operations around the world.',
      },
      {
        image: global.sgallery + '2.png',
        title: 'Secure Logistics',
        serial: '02',
        path: '/services/global-services/secure-logistics',
        shortDescription:
          "Let Brink's be your sole provider of secure logistics, managing the pick‑up, transit and delivery of your valuables.",
        description:
          "Let Brink's be your sole provider of secure logistics, managing the pick‑up, transit and delivery of your valuables.",
      },
      {
        image: global.sgallery + '3.jpg',
        title: 'Long Haul Transportation',
        serial: '03',
        path: '/services/global-services/long-haul-transportation',
        shortDescription:
          'High‑value transportation of valuable assets across countries and borders.',
        description:
          'High‑value transportation of valuable assets across countries and borders.',
      },
      {
        image: global.sgallery + '4.png',
        title: 'Distribution Solutions',
        serial: '04',
        path: '/services/global-services/distribution-solutions',
        shortDescription:
          'Secure and efficient, our distribution solutions are designed to support...',

        description:
          'Secure and efficient, our distribution solutions are designed to support your supply chain strategy.',
      },
      {
        image: global.sgallery + '5.jpg',
        title: 'Customs Clearance',
        serial: '05',
        path: '/services/global-services/customs-clearance',
        shortDescription:
          'Let our global network of customs experts help to reduce delays in your shipments.',

        description:
          'Let our global network of customs experts help to reduce delays in your shipments.',
      },
      {
        image: global.sgallery + '6.jpg',
        title: 'Secure Vaults and Bonded Warehouses',
        serial: '06',
        path: '/services/global-services/secure-vaults-and-bonded-warehouses',
        shortDescription:
          'Our high‑security warehousing protects products around the clock.',

        description:
          'Our high‑security warehousing protects your products around the clock.',
      },
    ],
  },

  estimation: {
    background: global.back + 'bg-2.jpg',
    title: 'Estimation',
    subtitle: 'Has a wide range of solutions',
    description:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry the standard dummy text ever since the  when an printer took.',
    solutions: [
      {
        serial: '01',
        title: 'Solutions and specialized expertise',
        subtitle:
          'Our aim is to optimize and improve your supply chain so that we can give you the best service',
      },
      {
        serial: '02',
        title: 'Multiple warehouses',
        subtitle:
          "We provide multiple drop off and pickup locations so you don't have to worry. And you should not face any kind...",
      },
      {
        serial: '03',
        title: 'Tracking made easy',
        subtitle:
          'A tracking number for the entire process. so that you can find the exact position. it will help you',
      },
    ],
  },

  booking: {
    background: global.booking + 'bg-map.png',
    image: global.booking + 'pic1.png',
    imageBack: '',
    title: 'Request A Quote',
    subtitle: 'Booking For Product Transformation',
    description:
      'Lorem Ipsum is simply dummy text of the printing and typesetting industry the standard dummy text ever since the when an printer took.',
    form: {
      quote: global.booking + 'icon1.png',
      track: global.booking + 'icon2.png',
    },
  },

  clients: [
    global.logo + 'w1.png',
    global.logo + 'w2.png',
    global.logo + 'w3.png',
    global.logo + 'w4.png',
    global.logo + 'w5.png',
    global.logo + 'w1.png',
    global.logo + 'w2.png',
    global.logo + 'w3.png',
    global.logo + 'w4.png',
    global.logo + 'w5.png',
  ],

  serviceDetails: {
    privateClientStorage: {
      title: 'Discreet, Secure & Insured Vault Solutions',
      description: (
        <span>
          Our Private Client Storage service offers individuals and institutions
          a secure and confidential way to store precious metals, high-value
          items, or sensitive assets. Whether you're an investor, collector, or
          family office, we provide dedicated vault space backed by
          military-grade security and full insurance coverage.
          <br />
          <br />
          We combine cutting-edge technology with personalized service to ensure
          your valuables are stored with complete discretion. With real-time
          access reporting, controlled viewing appointments, and tailored
          custody options, we give you peace of mind, knowing your assets are
          protected in a world-class facility.
        </span>
      ),
      image: global.sgallery + '/service-details/private-client-storage.jpg',
      subSection: {
        title: 'Why Choose Our Private Vaulting Solutions',
        description:
          'Designed for clients who demand the highest levels of security and privacy, our private storage solutions go beyond standard vault access.',
        image:
          global.sgallery + '/service-details/private-client-storage-sub.jpg',
        points: [
          'Private storage compartments',
          '24/7 monitored vaults',
          'Fully insured assets',
          'Anonymous storage options',
          'Appointment-based access',
          'Tamper-proof packaging',
          'Real-time tracking logs',
        ],
      },
    },
    secureLogistics: {
      title: 'Trusted Transportation for High-Value Assets',
      description: (
        <span>
          Our Secure Logistics service ensures the safe, insured, and discreet
          transportation of cash, gold, and other high-value assets. Using
          state-of-the-art armored vehicles and trained security personnel, we
          manage the full logistics chain — from pickup to final delivery.
          <br />
          <br />
          Whether you're moving precious metals, confidential documents, or
          large cash volumes, we offer peace of mind through real-time tracking,
          chain-of-custody protocols, and full regulatory compliance. Every
          transfer is handled with precision, care, and confidentiality.
        </span>
      ),
      image: global.sgallery + '/service-details/secure-logistics.jpg',
      subSection: {
        title: 'End-to-End Security in Motion',
        description: (
          <>
            From secure pickups to verified deliveries, our logistics operations
            are built for speed, precision, and complete asset protection.
            Customized routes and real-time updates ensure your valuables are
            always in safe hands.
          </>
        ),
        image: global.sgallery + '/service-details/secure-logistics-sub.jpg',
        points: [
          'Armored vehicle fleet',
          'Trained security staff',
          'Fully insured transit',
          'Real-time GPS tracking',
          'Chain-of-custody logs',
          'Discreet handling protocols',
          'On-demand route updates',
        ],
      },
    },
    longHaulTransportation: {
      title: 'Nationwide Security, Without Compromise',
      description: (
        <span>
          Our Long Haul Transportation service provides secure, insured movement
          of cash, gold, and valuables across cities, states, or regions.
          Designed for large-scale shipments and long-distance delivery, we
          ensure safety, efficiency, and compliance at every stage of the
          journey.
          <br />
          <br />
          Using advanced logistics planning, secure routing, and 24/7 monitored
          vehicles, we minimize risk while maintaining full visibility. Whether
          it’s inter-city transfers for banks, bullion transport for traders, or
          high-value retail cargo — your assets travel protected,
          professionally.
        </span>
      ),
      image: global.sgallery + '/service-details/long-haul-transportation.jpg',
      subSection: {
        title: 'Built for Distance, Backed by Security',
        description:
          'Our long-haul logistics network is designed for time-sensitive and high-value cargo that requires top-tier protection over extended distances.',
        image:
          global.sgallery +
          '/service-details/long-haul-transportation-sub.jpeg',
        points: [
          'Nationwide delivery routes',
          'Secure convoy options',
          'Live GPS monitoring',
          'Tamper-proof containers',
          'Cross-border compliance',
          'Insured long-distance transit',
          'Pre-approved secure stops',
        ],
      },
    },
    distributionSolutions: {
      title: 'Streamlined Delivery for Cash & Valuables',
      description: (
        <span>
          Our Distribution Solutions are designed to simplify and secure the
          last-mile delivery of cash, gold, and other high-value assets. We
          manage complex distribution networks with precision — ensuring timely,
          protected deliveries to multiple destinations across banking, retail,
          and enterprise sectors.
          <br />
          <br />
          Whether you're restocking ATMs, supplying retail branches, or managing
          change orders, our distribution model is scalable, real-time
          trackable, and built for reliability. From centralized vaults to
          doorstep delivery, we handle your assets as if they were our own.
        </span>
      ),
      image: global.sgallery + '/service-details/distribution-solutions.png',
      subSection: {
        title: 'Optimized for High-Volume Delivery',
        description:
          'Our distribution system supports businesses that require secure, repeated, and large-scale delivery operations with complete visibility and control.',
        image:
          global.sgallery + '/service-details/distribution-solutions-sub.avif',
        points: [
          'Multi-point distribution routes',
          'Fixed or flexible schedules',
          'Inventory reconciliation tools',
          'Real-time delivery tracking',
        ],
      },
    },
    customsClearance: {
      title: 'Smooth, Compliant Cross-Border Transfers',
      description: (
        <span>
          Our Customs Clearance service ensures the legal and secure movement of
          cash, gold, and other valuables across international borders. We
          handle all regulatory, documentation, and inspection processes to
          prevent delays and ensure full compliance with national and
          international laws.
          <br />
          <br />
          From import/export permits to real-time customs coordination, our
          experienced compliance team works closely with logistics operations to
          ensure seamless border transitions. Whether it’s a one-time transfer
          or a recurring operation, we simplify the complexities of customs so
          you can move assets with confidence.
        </span>
      ),
      image: global.sgallery + '/service-details/customs-clearance.jpg',
      subSection: {
        title: 'Expert Handling for International Movements',
        description:
          'We provide end-to-end support for cross-border asset transfers with a focus on speed, compliance, and full transparency throughout the customs process.',
        image: global.sgallery + '/service-details/customs-clearance-sub.jpg',
        points: [
          'Import/export documentation',
          'Cross-border coordination',
          'Regulatory compliance checks',
          'Customs inspection handling',
          'Duty and tax management',
          'Real-time clearance updates',
        ],
      },
    },
    secureVaultsAndBondedWarehouses: {
      title: 'Protected Storage, Global Access',
      description: (
        <span>
          Our Secure Vaults and Bonded Warehouses provide institutional-grade
          storage for cash, gold, precious metals, and high-value items. With
          advanced access control, redundant security layers, and full
          insurance, your assets remain protected under the highest standards of
          safety and compliance.
          <br />
          <br />
          Located in strategic, tax-efficient jurisdictions, our bonded
          warehouses offer duty-deferred storage options for international
          clients. Whether you're holding assets long-term or staging them for
          global distribution, we deliver total peace of mind with 24/7
          monitoring and audited custody protocols.
        </span>
      ),
      image: global.sgallery + '/service-details/secure-vaults.jpg',
      subSection: {
        title: 'Where Security Meets Compliance',
        description:
          'Our facilities are engineered for clients who need secure, transparent, and tax-efficient storage — whether for regulatory holding or flexible global trade.',
        image: global.sgallery + '/service-details/secure-vaults-sub.jpg',
        points: [
          '24/7 monitored vaults',
          'Bonded warehouse options',
          'Duty-deferred storage',
          'Climate-controlled units',
          'Multi-layer authentication',
          'Global storage locations',
        ],
      },
    },
  },
};
